module.exports = __webpack_public_path__ + "img/setting_color_white.c069cbfd.svg";